import { render } from "./MyOmnitrition.vue?vue&type=template&id=79ad4bd9&scoped=true"
import script from "./MyOmnitrition.vue?vue&type=script&lang=js"
export * from "./MyOmnitrition.vue?vue&type=script&lang=js"

import "./MyOmnitrition.vue?vue&type=style&index=0&id=79ad4bd9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ad4bd9"]])

export default __exports__